AuthenticatedRoutes;
import {
  Routes,
  Route,
  Outlet,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import DashboardRoutes from "../../modules/dashboard/router/DashboardRoutes";
import PortfolioRoutes from "../../modules/portfolio/router/PortfolioRoutes";
import UsinasRoutes from "../../modules/usinas/routes/UsinasRoutes";
import ClientsRoutes from "../../modules/clients/router/ClientsRoutes";
// import ClustersRoutes from "../../modules/clusters/router/ClusterRoutes";
import UserRoutes from "../../modules/users/router/UserRoutes";
import { Alert, CssBaseline, Snackbar, Fab } from "@mui/material";
import { Box } from "@mui/system";
import AsideMenu from "../components/AsideMenu";
import MobileMenu from "../components/MobileMenu";
import AlarmRoutes from "../../modules/alarms/router/AlarmRoutes";
import ServiceRequestRoutes from "../../modules/serviceRequest/router/ServiceRequestRoutes";
import PerfilRoutes from "../../modules/perfil/router/PerfilRoutes";
import BlipChatWidget, { BlipChatIcon } from "../../BlipChatWidget";
import FaqRoutes from "../../modules/faq/router/FaqRoutes";
import NotAuthenticatedErrorMessage from "../components/NotAuthentication";
import api from "../../services/api/api-instance";
import { useRopV2AppNative } from "../../modules/ropv2app/context/RopV2AppNativeContext";
import Loading from "../components/Loading";
import { UsinaByClient } from "../../modules/usinas/types";
import { UnauthorizedError } from "../../errors/errors";
import SqlQueriesRoutes from "../../modules/sqlQueries/router/SqlQueriesRoutes";
import Header from "../components/Header";
import OperationsRoutes from "../../modules/operations/router/OperationsRoutes";
import SolarGridControlRoutes from "../../modules/solarGridControl/router/SolarGridControlRoutes";
import SecondHeader from "../components/SecondHeader";

export default function AuthenticatedRoutes() {
  const {
    userIsAdm,
    userIsManutencao,
    bodyWidth,
    isMobile,
    bodyHeight,
    screenHeight,
    showBlipChat,
    setShowBlipChat,
    toastNotifications,
    setToastNotifications,
    setUser,
    isLoadingClientUsinas,
    selectedDashboardUsina: selectedUsina,
    layout,
  } = useContext(MainContext);

  const { pushDeviceId } = useRopV2AppNative();

  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [openToast, setOpenToast] = useState(false);
  const navigate = useNavigate();

  const { logout } = NotAuthenticatedErrorMessage(
    navigate,
    setUser,
    pushDeviceId
  );

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {
    if (toastNotifications.isAdding) {
      setOpenToast(true);
    }
  }, [toastNotifications]);

  const currentMessage =
    toastNotifications.notifications.length > 0
      ? toastNotifications.notifications[
      toastNotifications.notifications.length - 1
      ]
      : undefined;

  const handleClose = () => {
    setOpenToast(false);
    const filteredMessages = toastNotifications.notifications.filter(
      (message) => message !== currentMessage
    );
    setToastNotifications({ notifications: filteredMessages, isAdding: false });
  };

  function getErrorResponseText(errorDetails: string) {
    if (errorDetails == "usuário não tem acesso a usina e cliente")
      return "O usuário logado não tem acesso a usina nem ao cliente.";
    if (errorDetails == "usuário não tem acesso ao cliente")
      return "O usuário logado não tem acesso ao cliente.";
    if (errorDetails == "usuário não tem acesso a usina")
      return "O usuário logado não tem acesso a usina.";
    return "O usuário logado não possui acesso ao recurso requisitado";
  }

  useEffect(() => {
    const myInterceptor = api.interceptors.response.use(
      function (response) {
        return response;
      },
      // TODO: estudar a melhor forma de trabalhar com o service e componentes
      function (error) {
        if (error instanceof UnauthorizedError) {
          setToastNotifications({
            isAdding: true,
            notifications: [
              ...toastNotifications.notifications,
              {
                text: getErrorResponseText(error.message),
                severity: "error",
              },
            ],
          });
          const navigationPath = selectedUsina ? "/dashboard" : "/perfil";
          navigate(navigationPath);
        }
        if (error.message == "token inválida" || error.message == "token expirada") {
          setToastNotifications({
            isAdding: true,
            notifications: [
              ...toastNotifications.notifications,
              {
                text: "Desculpe, seu acesso expirou ou é inválido. Por favor, faça login novamente.",
                severity: "error",
              },
            ],
          });
          logout();
        }
        return Promise.reject(error);
      }
    );
    myInterceptor;
    return () => {
      api.interceptors.request.eject(myInterceptor);
    };
  }, []);

  const showSecondHeader = () => {
    switch (location.pathname) {
      case "/dashboard":
      case "/operations/center":
      case "/portfolio":
      case "/operations/control":
      case "/alarm/equipment-alarms-list":
      case "/service-request/list":
      case `/usinas/details/${selectedUsina?.usinaIds.id}`:
      case "/usinas/boletim-diario":
      case "/usinas/boletim-mensal":
      case "/usinas/boletim-personalizado":
      case "/usinas/boletim-parcial":
        return true;
      default:
        return false;
    }
  }

  const getTopValue = () => {
    switch (location.pathname) {
      case "/dashboard":
      case "/operations/center":
      case "/portfolio":
      case "/operations/control":
      case "/alarm/equipment-alarms-list":
      case "/service-request/list":
      case `/usinas/details/${selectedUsina?.usinaIds.id}`:
      case "/usinas/boletim-diario":
      case "/usinas/boletim-mensal":
      case "/usinas/boletim-personalizado":
      case "/usinas/boletim-parcial":
        return "84px";
      default:
        return "42px";
    }
  }

  return (
    <>
      {layout == LayoutsConfig.LayoutTwo &&
        <Header />}
      <Box
        sx={{
          display: "flex",
          height: screenHeight,
          alignItems: "center",
          justifyContent: isMobile ? "start" : "end",
          flexDirection: isMobile ? "column" : "row-reverse",

        }}
      >
        <CssBaseline />
        {isLoadingClientUsinas ? (
          <Loading />
        ) : (
          <Box sx={{
            width: bodyWidth,
            height: bodyHeight,
          }}>
            {showSecondHeader() && !isMobile &&
              <SecondHeader />
            }
            <Box
              style={{
                width: bodyWidth,
                height: bodyHeight,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflowY: "auto",
                transition: "width 0.3s",
                top: layout == LayoutsConfig.LayoutTwo ? getTopValue() : "0px",
                position: layout == LayoutsConfig.LayoutTwo ? "fixed" : undefined
              }}
              ref={scrollRef}
            >
              {/* <IconButton>
              <ChatIcon />
              </IconButton> */}
              <BlipChatWidget show={showBlipChat} setShow={setShowBlipChat} />

              {currentMessage && (
                <>
                  <Snackbar
                    open={openToast}
                    autoHideDuration={getAutoHideDurations(
                      currentMessage.severity
                    )}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    ClickAwayListenerProps={{ onClickAway: () => null }}
                  >
                    <Alert
                      onClose={handleClose}
                      severity={currentMessage.severity}
                      sx={{ width: "100%" }}
                    >
                      {currentMessage.text}
                    </Alert>
                  </Snackbar>
                </>
              )}

              <Routes>
                <Route
                  path="/*"
                  element={
                    <Navigate
                      to={getInitialRoute(userIsManutencao, selectedUsina)}
                    />
                  }
                />
                {/* {userIsAdm && ( */}
                {/* <Route path="/clusters/*" element={<ClustersRoutes />} /> */}
                <Route path="/users/*" element={<UserRoutes />} />
                <Route path="/faq/*" element={<FaqRoutes />} />
                <Route path="/usinas/*" element={<UsinasRoutes />} />
                <Route path="/clients/*" element={<ClientsRoutes />} />
                {/* <Route path="/dashboard/*" element={<DashboardRoutes />} /> */}
                {/* <Route path="/portfolio/*" element={<PortfolioRoutes />} /> */}
                <Route path="/alarm/*" element={<AlarmRoutes />} />
                <Route path="/perfil/*" element={<PerfilRoutes />} />
                {userIsAdm && (
                  <Route path="/sql-queries/*" element={<SqlQueriesRoutes />} />
                )}
                <Route
                  path="/service-request/*"
                  element={<ServiceRequestRoutes />}
                />
                <Route path="/operations/*" element={<OperationsRoutes />} />
                <Route
                  path="/operations/control/*"
                  element={<SolarGridControlRoutes />}
                />
                <Route path="/dashboard/*" element={<DashboardRoutes />} />
                <Route path="/portfolio/*" element={<PortfolioRoutes />} />
              </Routes>
              <Outlet />
              <Fab
                sx={{
                  position: "fixed",
                  bottom: { xs: 50, md: 10 },
                  right: 10,
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onClick={() => {
                  setShowBlipChat(!showBlipChat);
                }}
                aria-label="edit"
              >
                <BlipChatIcon />
              </Fab>
            </Box>
          </Box>
        )}
        {isMobile ? <MobileMenu /> : <AsideMenu />}
      </Box>
    </>
  );
}

function getAutoHideDurations(
  severity: "error" | "warning" | "info" | "success"
) {
  switch (severity) {
    case "error":
      return undefined;
    case "warning":
      return 6000;
    case "info":
      return 6000;
    case "success":
      return 6000;
  }
}

export function getInitialRoute(
  userIsManutencao: boolean,
  selectedUsina: UsinaByClient | undefined
): string {
  if (userIsManutencao) return "/perfil";
  if (selectedUsina !== undefined) return "/dashboard";
  return "/perfil";
}
